import React, { ComponentProps } from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { useWorkspace, WorkspaceConfig } from '../../graphql/hooks/useWorkspace';
import CustomerGlobalContact from '../../graphql/entities/customer/CustomerGlobalContact';
import { ICustomerGlobalContact } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const CUSTOMER_GLOBAL_CONTACT_FIELD_NAMES: Array<Paths<ICustomerGlobalContact>> = ['name.fullName'];

const { type, workspace, title, formUrl } = CustomerGlobalContact;

const CustomerGlobalContactWorkspace = (
  props: WorkspaceConfig<ICustomerGlobalContact> & Omit<ComponentProps<typeof Workspace>, 'entity'>
) => {
  const workspaceProps = useWorkspace<ICustomerGlobalContact>(props, CustomerGlobalContact, {
    columns: CUSTOMER_GLOBAL_CONTACT_FIELD_NAMES,
    initialSortColumn: 'name.fullName',
  });
  return (
    <Workspace
      entityType={type}
      formUrl={formUrl}
      title={title}
      defaultQuery={workspace}
      {...workspaceProps}
      {...props}
      entity={CustomerGlobalContact}
    />
  );
};

export default CustomerGlobalContactWorkspace;
